// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../mini-css-extract-plugin/dist/loader.js??ruleSet[1].rules[3].use[1]!../css-loader/dist/cjs.js!../postcss-loader/dist/cjs.js??ruleSet[1].rules[3].use[3]!../sass-loader/dist/cjs.js??ruleSet[1].rules[3].use[4]!./graphiql.css");
if(content.__esModule) content = content.default;
if(typeof content === 'string') content = [[module.id, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var add = require("!../vue-style-loader/lib/addStylesClient.js").default
var update = add("6cd65dd1", content, true, {});